import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

// O Bearer de integracao do Protheus agora e injetado pelo BFF (server-side,
// /etc/gnf-bff.env). O front NAO minta mais token com credencial - por isso
// getToken() retorna vazio e o interceptor nao envia Authorization (quem poe
// e o BFF). Mantido o contrato (getToken/invalidate) pra nao mexer no
// interceptor alem do necessario.
@Injectable({ providedIn: 'root' })
export class ProtheusAuthService {
  getToken(): Observable<string> {
    return of('');
  }

  invalidate(): void {
    // no-op: o ciclo de vida do Bearer e responsabilidade do BFF.
  }
}
